import React from 'react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { useAccessibility } from '@/contexts/AccessibilityContext';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

const RateLimitModal = ({ open, onClose }) => {
  const { t } = useLanguage();
  const { lightMode } = useAccessibility();

  if (!open) return null;

  const handleBackdropClick = () => {
    onClose?.();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="rate-limit-modal-title"
        className={cn(
          "max-w-md w-full rounded-3xl p-6 space-y-4 shadow-xl border relative",
          "max-h-[90dvh] overflow-y-auto overscroll-contain",
          lightMode
            ? "bg-white border-gray-200"
            : "bg-[#020617] border-slate-800"
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className={cn(
            "absolute top-4 right-4 w-11 h-11 min-w-[44px] min-h-[44px] flex items-center justify-center rounded-full transition-colors touch-manipulation",
            lightMode
              ? "bg-gray-100 hover:bg-gray-200 text-gray-600"
              : "bg-white/10 hover:bg-white/20 text-white/70"
          )}
          aria-label={t('rateLimit.close')}
        >
          <X className="w-5 h-5" />
        </button>

        {/* Icon */}
        <div className={cn(
          "w-16 h-16 rounded-full flex items-center justify-center text-3xl mx-auto",
          lightMode ? "bg-gray-100" : "bg-white/10"
        )}>
          ⏱️
        </div>

        {/* Title */}
        <h2
          id="rate-limit-modal-title"
          className={cn(
            "text-2xl font-bold text-center",
            lightMode ? "text-gray-900" : "text-white"
          )}
        >
          {t('rateLimit.title')}
        </h2>

        {/* Message */}
        <p className={cn(
          "text-center text-base leading-relaxed",
          lightMode ? "text-gray-600" : "text-white/80"
        )}>
          {t('rateLimit.message')}
        </p>

        {/* Action button */}
        <div className="pt-2">
          <Button
            onClick={onClose}
            className={cn(
              "w-full font-bold min-h-[48px] text-base",
              lightMode
                ? "bg-gray-900 hover:bg-gray-800 text-white"
                : "bg-[#7EE2C3] hover:bg-[#6BD4B5] text-black"
            )}
          >
            {t('rateLimit.ok')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RateLimitModal;
